"use client";

import { c as _c } from "react/compiler-runtime";
import { CameraIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import type { ChangeEvent, DragEvent } from "react";
import { AuthContext } from "@/components/auth/Auth";
const ACCEPTED_FORMATS = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
const ACCEPTED_FORMATS_DISPLAY = ACCEPTED_FORMATS.map(format => `.${format.replace("image/", "")}`).join(", ");
const FILE_SIZE_LIMIT = 10485760;
export default function CreateWaveImageInput(t0) {
  const $ = _c(34);
  const {
    imageToShow,
    setFile,
    allowRemove: t1
  } = t0;
  const allowRemove = t1 === undefined ? true : t1;
  const {
    setToast
  } = useContext(AuthContext);
  const inputRef = useRef(null);
  let t2;
  if ($[0] !== setFile || $[1] !== setToast) {
    t2 = file => {
      if (ACCEPTED_FORMATS.indexOf(file.type) === -1) {
        setToast({
          type: "error",
          message: "Invalid file type"
        });
      } else {
        if (file.size > FILE_SIZE_LIMIT) {
          setToast({
            type: "error",
            message: "File size must be less than 10MB"
          });
        } else {
          setFile(file);
        }
      }
    };
    $[0] = setFile;
    $[1] = setToast;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onFileChange = t2;
  let t3;
  if ($[3] !== onFileChange) {
    t3 = e => {
      e.preventDefault();
      e.stopPropagation();
      const file_0 = e.dataTransfer.files.item(0);
      if (file_0 !== null) {
        onFileChange(file_0);
      }
    };
    $[3] = onFileChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleDrop = t3;
  const [dragging, setDragging] = useState(false);
  let t4;
  if ($[5] !== imageToShow) {
    t4 = imageToShow ? URL.createObjectURL(imageToShow) : null;
    $[5] = imageToShow;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const previewUrl = t4;
  let t5;
  let t6;
  if ($[7] !== previewUrl) {
    t5 = () => () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
    t6 = [previewUrl];
    $[7] = previewUrl;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      if (e_0.type === "dragenter" || e_0.type === "dragover") {
        setDragging(true);
      } else {
        if (e_0.type === "dragleave") {
          setDragging(false);
        } else {
          if (e_0.type === "drop") {
            setDragging(false);
          }
        }
      }
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleDrag = t7;
  let t8;
  if ($[11] !== imageToShow || $[12] !== previewUrl) {
    t8 = <div className="tw-flex-shrink-0">{imageToShow ? <Image src={previewUrl ?? ""} alt="Profile image" width={80} height={80} unoptimized={true} loader={_temp} className="tw-h-14 tw-w-14 tw-flex-shrink-0 tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900 tw-object-cover sm:tw-h-20 sm:tw-w-20" /> : <div className="tw-flex tw-h-14 tw-w-14 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900 tw-object-cover tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-border-white/10 hover:tw-bg-iron-800 hover:tw-text-iron-300 sm:tw-h-20 sm:tw-w-20"><CameraIcon aria-hidden="true" className="tw-h-5 tw-w-5 sm:tw-h-6 sm:tw-w-6" /></div>}</div>;
    $[11] = imageToShow;
    $[12] = previewUrl;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== allowRemove || $[15] !== imageToShow || $[16] !== setFile) {
    t9 = imageToShow && allowRemove && <button onClick={() => setFile(null)} type="button" aria-label="Remove file" className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-red tw-transition tw-duration-200 tw-ease-out hover:tw-bg-red/10">Delete</button>;
    $[14] = allowRemove;
    $[15] = imageToShow;
    $[16] = setFile;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-1.5">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = ` ${dragging ? "tw-border-white/20 tw-bg-iron-900" : "tw-border-white/10 tw-bg-iron-900/60"} tw-flex tw-h-40 tw-w-full tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-dashed tw-transition tw-duration-300 tw-ease-out hover:tw-border-white/20 hover:tw-bg-iron-900`;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out group-hover:tw-border-white/20"><div className="tw-flex tw-h-4 tw-w-4 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-5">{t12}<p className="tw-mb-1 tw-mt-3 tw-text-xs tw-font-normal tw-text-iron-400 sm:tw-text-sm"><span className="tw-font-medium tw-text-white">Click to upload</span>{" "}or drag and drop</p><p className="tw-mb-0 tw-text-xs tw-font-normal tw-text-iron-500">JPEG, JPG, PNG, GIF, WEBP</p></div>;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== onFileChange) {
    t14 = <input id="pfp-upload-input" ref={inputRef} type="file" className="tw-hidden" accept={ACCEPTED_FORMATS_DISPLAY} onChange={e_1 => {
      const files = e_1.target.files;
      if (files !== null) {
        const file_1 = files.item(0);
        if (file_1 !== null) {
          onFileChange(file_1);
        }
      }
    }} />;
    $[23] = onFileChange;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14) {
    t15 = <label className={t11}>{t13}{t14}</label>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== handleDrop || $[29] !== t15) {
    t16 = <div onDrop={handleDrop} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} className="tw-group tw-relative tw-flex tw-w-full tw-items-center tw-justify-center">{t15}</div>;
    $[28] = handleDrop;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t10 || $[32] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-x-5">{t10}{t16}</div>;
    $[31] = t10;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
function _temp(t0) {
  const {
    src
  } = t0;
  return src;
}